import moment from 'moment'
import { personService } from '@/services/person.service'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'PersonDialogDataTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        },
        update:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // model del menu de fecha de nacimiento
        menuDateOfBirth: false,
        // fecha formateada
        selectedDateOfBirth: '',
        // estados civiles
        civilStatusItems: [],
        // loading estados civiles
        loadingCivilStatus: false,
    }),
    computed: {
    },
    created () {
    },
    mounted () {
        this.getCivilStatus()
    },
    methods: {
        /**
         * Carga los estados civiles en el selector
         */
        async getCivilStatus () {
            this.loadingCivilStatus = true
            this.civilStatusItems = await personService.getCivilStatus()
            this.loadingCivilStatus = false
        },
        /**
         * Lo ejecuta el menú para seleccionar la fecha de nacimiento
         */
        closeDateOfBirthMenu () {
            this.menuDateOfBirth = false
        },
        /**
         * Cada vez que se modifica la selección de estado civil, se cargan
         */
        civilStatusSelectedFunction (newValue) {
            this.model.civilStatus = newValue.id ? newValue.id : newValue;
        },
        clearCivilStatus(val) {
            if (val) {
                this.model.civilStatus = null;
            }
        },
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Actualizo el valor de la fecha de nacimiento
         */
        model: {
            deep: true,
            immediate: true,
            handler() {
                this.selectedDateOfBirth = this.model.dateOfBirth ? moment(this.model.dateOfBirth).format('DD/MM/YYYY') : ''
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.personDialogDataTabForm) {
                this.$refs.personDialogDataTabForm.resetValidation()
            }
        }
    }
}
